import { tw } from "@careinfo/tailwind";
import React, { useRef, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";

const SignaturePad = ({
  setValue,
  name = "signature",
  clearErrors,
  errors,
}: any) => {
  const sigCanvas = useRef<SignatureCanvas | null>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const canvas = sigCanvas.current?.getCanvas();
    const wrapper = wrapperRef.current;

    if (canvas && wrapper) {
      canvas.width = wrapper.offsetWidth;
      canvas.height = 200;
    }
  }, []);

  const handleEnd = () => {
    const canvasInstance = sigCanvas.current;
    if (!canvasInstance || canvasInstance.isEmpty()) return;
    const trimmedCanvas = canvasInstance.getTrimmedCanvas();
    const dataURL = trimmedCanvas.toDataURL("image/png");
    const file = dataURLtoFile(dataURL, "signature.png");

    setValue(name, file, { shouldValidate: true });
  };

  const clear = () => {
    sigCanvas.current?.clear();
    setValue(name, null);
    clearErrors?.(name);
  };

  return (
    <div ref={wrapperRef} className="w-full">
      <label htmlFor="">
        <div className={tw`flex items-center justify-between`}>
          <span>Signature</span>
          <button
            type="button"
            className={tw`focus:outline-none`}
            onClick={clear}
          >
            Clear
          </button>
        </div>
      </label>
      <SignatureCanvas
        ref={sigCanvas}
        onEnd={handleEnd}
        canvasProps={{
          className: "w-full h-[200px] border rounded",
        }}
      />
      {errors && (
        <p className={tw`text-red-500 text-xs my-1`}>{errors?.message}</p>
      )}
    </div>
  );
};

export default SignaturePad;

function dataURLtoFile(dataurl: string, filename: string): File {
  const arr = dataurl.split(",");
  const mime = arr[0].match(/:(.*?);/)?.[1] || "image/png";
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) u8arr[n] = bstr.charCodeAt(n);
  return new File([u8arr], filename, { type: mime });
}
